@if ({}; as STATE) {
  <section class="ntd-page">
    <auth-wrapper [title]="title" [description]="description">
      <ntd-verification-form></ntd-verification-form>
    </auth-wrapper>
  </section>
}
